"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _lodash = _interopRequireDefault(require("lodash.get"));

var _jwtDecode = _interopRequireDefault(require("jwt-decode"));

var _BaseClient2 = _interopRequireDefault(require("./BaseClient"));

var CoamClient =
/*#__PURE__*/
function (_BaseClient) {
  (0, _inherits2["default"])(CoamClient, _BaseClient);

  function CoamClient(getAccessToken) {
    (0, _classCallCheck2["default"])(this, CoamClient);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(CoamClient).call(this, getAccessToken, 'https://api.cimpress.io'));
  }

  (0, _createClass2["default"])(CoamClient, [{
    key: "hasPermissionsFor",
    value: function () {
      var _hasPermissionsFor = (0, _asyncToGenerator2["default"])(
      /*#__PURE__*/
      _regenerator["default"].mark(function _callee(resourceType, resourceIdentifier, permission) {
        var user, canonicalId, statusCode;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                user = (0, _jwtDecode["default"])(this.getAccessToken());
                canonicalId = user['https://claims.cimpress.io/canonical_id'];
                _context.prev = 2;
                _context.next = 5;
                return this.fetchWithAuth({
                  endpointUrl: this.endpointUrl,
                  route: "auth/access-management/v1/principals/".concat(encodeURIComponent(canonicalId), "/permissions/").concat(encodeURIComponent(resourceType), "/").concat(encodeURIComponent(resourceIdentifier), "/").concat(encodeURIComponent(permission))
                });

              case 5:
                _context.next = 15;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](2);
                statusCode = (0, _lodash["default"])(_context.t0, 'response.status');
                _context.t1 = statusCode;
                _context.next = _context.t1 === 404 ? 13 : 14;
                break;

              case 13:
                return _context.abrupt("return", false);

              case 14:
                throw new Error("An unknown error occurred when checking user permission. (".concat(statusCode, ")"));

              case 15:
                return _context.abrupt("return", true);

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[2, 7]]);
      }));

      function hasPermissionsFor(_x, _x2, _x3) {
        return _hasPermissionsFor.apply(this, arguments);
      }

      return hasPermissionsFor;
    }()
  }]);
  return CoamClient;
}(_BaseClient2["default"]);

exports["default"] = CoamClient;